import { render } from "./IconStar.vue?vue&type=template&id=33308cb5"
import script from "./IconStar.vue?vue&type=script&lang=js"
export * from "./IconStar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__